import { ISetTieuChuanHocSinhActions } from "../../action-types/set-tieu-chuan/ISetTieuChuanHocSinhActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISetTieuChuanHocSinhReducer } from "../../reducer-model/set-tieu-chuan/ISetTieuChuanHocSinhReducer";

const iniState: ISetTieuChuanHocSinhReducer = {
    status: eReducerStatusBase.is_not_initialization,
    statusCombo: eReducerStatusBase.is_not_initialization,
    setTieuChuanHocSinhs: [],
    isShowAddComboModal: false,
    hocSinhs: [],
    ts_hocsinh_ids: [],
    dm_truong_ids: [],
    dm_khoi_ids: [],
    dm_he_ids: [],
    dm_lop_ids: [],
    dm_gioitinh_ids: [],
    uf_settieuchuan_id: 0,
    dm_trangthaihocsinh_ids: [],
    setTieuChuanHocSinhPendings: []
}

export const setTieuChuanHocSinhReducer = (state: ISetTieuChuanHocSinhReducer = iniState, action: ISetTieuChuanHocSinhActions): ISetTieuChuanHocSinhReducer => {
    switch (action.type) {
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                setTieuChuanHocSinhs: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_HOC_SINH_SHOW_EDIT_MODAL":
            return {
                ...state,
                setTieuChuanHocSinhEditing: action.payload,
                isShowEditModal: true
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false
            }

        case "SET_TIEU_CHUAN_HOC_SINH_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "SET_TIEU_CHUAN_HOC_SINH_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_HOC_SINH_UPDATE_PHAT_DONG_PHUC_SUCCESS":
            const updatedItem = action.payload;
            return {
                ...state,
                setTieuChuanHocSinhs: state.setTieuChuanHocSinhs.map(item =>
                    item.id === updatedItem.id ? updatedItem : item
                )
            }
        case "SET_TIEU_CHUAN_HOC_SINH_SHOW_ADD_COMBO_MODAL":
            return {
                ...state,
                isShowAddComboModal: true
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CLOSE_ADD_COMBO_MODAL":
            return {
                ...state,
                isShowAddComboModal: false,
                status: eReducerStatusBase.is_need_reload

            }
        case "SET_TIEU_CHUAN_HOC_SINH_SAVE_ADD_COMBO_START":
            return {
                ...state,
                statusCombo: eReducerStatusBase.is_saving
            }
        case "SET_TIEU_CHUAN_HOC_SINH_SAVE_ADD_COMBO_SUCCESS":
            return {
                ...state,
                isShowAddComboModal: false,
                statusCombo: eReducerStatusBase.is_completed,
                status: eReducerStatusBase.is_need_reload,
                ts_hocsinh_ids: []
            }
        case "SET_TIEU_CHUAN_HOC_SINH_SAVE_ADD_COMBO_ERROR":
            return {
                ...state,
                statusCombo: eReducerStatusBase.is_completed,
                status: eReducerStatusBase.is_need_reload,
                ts_hocsinh_ids: []
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_HOCSINH_START":
            return {
                ...state,
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_HOCSINH_SUCCESS":
            return {
                ...state,
                hocSinhs: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_HOCSINH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_HOCSINH_SELECTED_IDS":
            return {
                ...state,
                ts_hocsinh_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_TRUONG_SELECTED_IDS":
            return {
                ...state,
                dm_truong_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_KHOI_SELECTED_IDS":
            return {
                ...state,
                dm_khoi_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_HE_SELECTED_IDS":
            return {
                ...state,
                dm_he_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_LOP_SELECTED_IDS":
            return {
                ...state,
                dm_lop_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_GIOITINH_SELECTED_IDS":
            return {
                ...state,
                dm_gioitinh_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_COMBO_SELECTED_ID":
            return {
                ...state,
                uf_settieuchuan_id: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_CHANGED_TRANGTHAI_SELECTED_IDS":
            return {
                ...state,
                dm_trangthaihocsinh_ids: action.payload
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_COMBO_PENDING_START":
            return {
                ...state,
            }
        case "SET_TIEU_CHUAN_HOC_SINH_LOAD_COMBO_PENDING_SUCCESS":
            return {
                ...state,
                setTieuChuanHocSinhPendings: action.payload
            }
        default:
            return state;
    }
}
